;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import {Slot} from "@radix-ui/react-slot";
import {cva, type VariantProps} from "class-variance-authority";
import type * as React from "react";
import {cn} from "@/utilities/ui";

const buttonVariants = cva("button", {
	defaultVariants: {
		size: "default",
		variant: "primary",
	},
	variants: {
		size: {
			clear: "",
			default: "",
			icon: "",
			lg: "",
			sm: "",
		},
		variant: {
			primary: "-primary",
			secondary: "-secondary",
			tertiary: "-tertiary",
			inline: "-clean",
			none: "-none",
		},
	},
});

export interface ButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement>,
		VariantProps<typeof buttonVariants> {
	asChild?: boolean;
	ref?: React.Ref<HTMLButtonElement>;
}

const Button: React.FC<ButtonProps> = ({
	asChild = false,
	className,
	size,
	variant,
	ref,
	...props
}) => {
	const Comp = asChild ? Slot : "button";
	return (
		<Comp
			className={cn(buttonVariants({ className, size, variant }))}
			ref={ref}
			{...props}
		/>
	);
};

export { Button, buttonVariants };
